const asObject = (value) => (value && typeof value === "object" && !Array.isArray(value) ? value : null);

const pickItems = (payload, itemKeys = []) => {
  if (Array.isArray(payload)) return payload;

  const root = asObject(payload);
  if (!root) return [];

  if (Array.isArray(root.data)) return root.data;

  const nested = asObject(root.data);
  if (nested) {
    if (Array.isArray(nested.data)) return nested.data;
    for (const key of itemKeys) {
      if (Array.isArray(nested[key])) return nested[key];
    }
  }

  for (const key of itemKeys) {
    if (Array.isArray(root[key])) return root[key];
  }

  return [];
};

const pickMetaSource = (payload) => {
  const layers = [];
  const addLayer = (layer) => {
    const object = asObject(layer);
    if (!object) return;
    layers.push(object);
    if (asObject(object.meta)) layers.push(object.meta);
    if (asObject(object.pagination)) layers.push(object.pagination);
  };

  const root = asObject(payload);
  if (!root) return {};
  addLayer(root);
  addLayer(root.data);

  const source = {};
  layers.forEach((layer) => {
    ["current_page", "last_page", "per_page", "total", "from", "to"].forEach((key) => {
      if (layer[key] !== undefined && layer[key] !== null && layer[key] !== "") {
        source[key] = layer[key];
      }
    });
  });
  return source;
};

export const normalizeListPayload = (payload, { itemKeys = [], perPage } = {}) => {
  const items = pickItems(payload, itemKeys);
  const source = pickMetaSource(payload);
  const requestedPerPage = Number(perPage) || 0;
  const total = Number(source.total);
  const resolvedTotal = Number.isFinite(total) ? total : items.length;
  const resolvedPerPage = Number(source.per_page) || requestedPerPage || items.length || 20;
  const currentPage = Number(source.current_page) || 1;
  const lastPage = Math.max(
    Number(source.last_page) || 1,
    Math.max(1, Math.ceil((resolvedTotal || 0) / (resolvedPerPage || 1)) || 1)
  );

  return {
    items,
    meta: {
      current_page: currentPage,
      last_page: lastPage,
      per_page: resolvedPerPage,
      total: resolvedTotal,
      from: source.from,
      to: source.to,
    },
  };
};
